
import { Component, Prop, Vue } from "vue-property-decorator";
import Table from "../../../domain/restaurant/Table";
import Booking from "../../../domain/booking/Booking";
import Room from "@/domain/restaurant/Room";

@Component
export default class BookingsByTableCard extends Vue {
  @Prop()
  table!: Table;

  @Prop({ default: () => [] })
  bookings!: Booking[];

  @Prop({ default: () => {} })
  tables!: { [key: number]: Table };

  get hasBookings() {
    for (let i = 0; i < this.bookings.length; i++) {
      if (this.bookings[i].tableId === this.table.tableId) return true;
    }
    return false;
  }

  get cardColour() {
    if (this.hasBookings) {
      return "white";
    } else {
      return "grey lighten-3";
    }
  }

  getTableFromId(tableId: number) {
    if (this.tables[tableId] != null) return this.tables[tableId];
    return new Table();
  }

  getRoomColour() {
    return Room.getRoomColourFromId(this.table.roomId);
  }
}
